module.exports = __webpack_public_path__ + "img/Contenedor papel confidencial.a1b55183.jpg";